import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const NotFound: React.FC = () => {

    const goToHome = () => {
        window.location.href = 'https://www.dafabet.com/en'; // Redirect to the Dafabet home page
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                textAlign: 'center',
                backgroundColor: '#f5f5f5',
                padding: '20px',
            }}
        >
            <Typography variant="h1" sx={{ fontWeight: 'bold', color: '#ff0000' }}>
                404
            </Typography>
            <Typography variant="h5" sx={{ margin: '20px 0', color: '#333' }}>
                Oops! The page you are looking for does not exist.
            </Typography>
            <Typography variant="body1" sx={{ marginBottom: '40px', color: '#666' }}>
                It might have been removed, renamed, or did not exist in the first place.
            </Typography>
            <Button
                variant="contained"
                color="primary"
                onClick={goToHome}
                sx={{
                    backgroundColor: '#ff5722',
                    '&:hover': {
                        backgroundColor: '#e64a19',
                    },
                    padding: '10px 20px',
                    fontWeight: 'bold',
                    fontSize: '16px',
                }}
            >
                Go Back to Home
            </Button>
        </Box>
    );
};

export default NotFound;
